module.exports = __webpack_public_path__ + "media/images/teams/logo__15-aeb9fd8b1d0051ededb5ee5de8cc4fb3.svg";